<template>
  <div class="page flex-col">
    <div class="section_1 flex-row justify-between">
      <div class="box_1 flex-col justify-between">
        <div class="group_1 flex-row">
          <img
            class="image_1"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPng5883156b8da4043741c187d56b545a4c73f5275362e552ecb4ccd915f82b670a.png"
          />
          <div class="text-wrapper_1 flex-col justify-between">
            <span class="text_1">刷题</span>
            <span class="text_2">200题精选</span>
          </div>
        </div>
        <div class="group_2 flex-row">
          <img
            class="image_2"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPngf4c8fad08f67327d71884c49c25b9f18eb2737bad7e02350ad58e9f7fbcad65d.png"
          />
          <div class="text-wrapper_2 flex-col justify-between">
            <span class="text_3">笔试</span>
            <span class="text_4">加油！祝您成功</span>
          </div>
        </div>
      </div>
      <div class="box_2 flex-col">
        <span class="text_5">预约考试</span>
        <span class="text_6">预约考试后可开始刷题</span>
        <span class="text_7">岗位</span>
        <div class="section_2 flex-row justify-between">
          <span class="text_8">UI工程师</span>
          <img
            class="thumbnail_1"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPnga36a66c75779472a87823b57652aff4ea62f92d1bd5e96aee5567578f28cc95f.png"
          />
        </div>
        <span class="text_9">时间</span>
        <div class="section_3 flex-row justify-between">
          <div class="text-wrapper_3 flex-col"><span class="text_10">2025-12-23</span></div>
          <div class="text-wrapper_4 flex-col"><span class="text_11">12:00</span></div>
        </div>
        <div class="text-wrapper_5 flex-col"><span class="text_12">进入</span></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      constants: {}
    };
  },
  methods: {}
};
</script>
<style scoped lang="scss" src="./assets/index.scss" />